<div class="register-container">
    <form #registerForm="ngForm" class="form-register" (ngSubmit)="registerForm.form.valid && register()"
          novalidate>
        <h1 class="h3 mb-3 font-weight-normal">Register</h1>
        <div class="form-group">
            <label for="firstName">First name *</label>
            <input type="text" class="form-control" id="firstName" required
                   placeholder="Enter your first name"
                   [(ngModel)]="user.firstName" name="firstName"
                   #firstName="ngModel">
            <div [hidden]="firstName.valid || firstName.pristine" class="alert alert-danger">
                First name is required
            </div>
        </div>
        <div class="form-group">
            <label for="lastName">Last name *</label>
            <input type="text" class="form-control" id="lastName" required
                   placeholder="Enter your last name"
                   [(ngModel)]="user.lastName" name="lastName"
                   #lastName="ngModel">
            <div [hidden]="lastName.valid || lastName.pristine" class="alert alert-danger">
                Last name is required
            </div>
        </div>
        <div class="form-group">
             <label for="emailAddress">Email address *</label>
             <input type="email" class="form-control" id="emailAddress" required email
                    placeholder="Enter your email address"
                    [(ngModel)]="user.emailAddress" name="emailAddress"
                    #emailAddress="ngModel">
             <div [hidden]="emailAddress.valid || emailAddress.pristine"
                  class="alert alert-danger">
                 A valid email address is required
             </div>
        </div>
         <div class="form-group">
             <label for="password">Password *</label>
             <input type="password" class="form-control" id="password"
                    required
                    minlength="10"
                    appPasswordComplexity
                    placeholder="Enter a password"
                    [(ngModel)]="user.password" name="password"
                    #password="ngModel">
             <div *ngIf="password.invalid && (password.dirty || password.touched)" class="alert alert-danger">
                 <div *ngIf="password.errors.required">
                     Password is required
                 </div>
                 <div *ngIf="password.errors.minlength">
                     Password must be at least 10 characters long.
                 </div>
                 <div>
                     {{ password.errors.passwordComplexity }}
                 </div>
             </div>
        </div>
        <div class="form-group">
             <label for="confirmPassword">Confirm password *</label>
             <input type="password" class="form-control" id="confirmPassword"
                    required
                    placeholder="Enter a password"
                    name="confirmPassword"
                    [(ngModel)]="passwordCheck"
                    #confirmPassword="ngModel"
                    pattern="{{ user.password }}">
             <div *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)" class="alert alert-danger">
                 <div *ngIf="confirmPassword.errors.required">
                     Confirm your password
                 </div>
                 <div *ngIf="confirmPassword.errors.pattern">
                     Password and confirm password must match.
                 </div>
             </div>
        </div>
        <div class="form-group">
             <label for="organisationName">Organisation name</label>
             <input type="text" class="form-control" id="organisationName"
                    placeholder="Enter your organisation name"
                    [(ngModel)]="user.organisationName" name="organisationName"
                    #organisationName="ngModel">
        </div>
        <div class="form-check">
            <input type="checkbox" class="form-check-input" id="termsAndConditions"
                   name="termsAndConditions" required
                   [(ngModel)]="termsAndConditionsChecked"
                   #termsAndConditions="ngModel">
            <label class="form-check-label" for="termsAndConditions">
                I agree to the
                <a href="/terms-conditions" target="_blank">Terms and Conditions</a> and
                <a href="/privacy-policy" target="_blank">Privacy Policy</a>
            </label>
            <div  [hidden]="termsAndConditions.valid || termsAndConditions.pristine" class="alert alert-danger">
                You first need to accept the Terms and Conditions and the Privacy Policy.
            </div>
        </div>
        <div class="form-check">
            <input type="checkbox" class="form-check-input" id="marketingConsent"
                name="marketingConsent"
                [(ngModel)]="user.marketingConsent" #marketingConsent="ngModel">
            <label class="form-check-label" for="marketingConsent">
                We would like to use your details to keep you informed about our products, service and events.
                If you consent to receiving this information please tick the box.
            </label>
        </div>
        <!-- ERROR -->
        <div>
            <api-error [apiError]="apiError"></api-error>
        </div>
        <!-- SUCCESS -->
        <div class="alert alert-primary" *ngIf="userCreationSuccess">
            Your account has been created successfully. Please verify your account by following the link in the
            email sent to you. It might take a few minutes before you receive your email. Please check your spam folder
            if you have not received your email within a few minutes.
        </div>
        <div class="form-group">
            <button class="btn btn-lg btn-primary btn-block" type="submit"
                    [disabled]="!registerForm.form.valid || userCreationSuccess">
                Register
            </button>
        </div>
    </form>
</div>